import React from 'react'

import Modal from 'react-modal'
import Loader from 'react-loader-spinner'

import Question from '@mui/icons-material/HelpOutline'

import Button from '@mui/material/Button'

// import Colors from '../../common/colors'
import { stringFromStringWithLineBreaks } from './common'


export default class ConfirmDialog extends React.PureComponent {

  // static propTypes = {
  //   message: PropTypes.string.isRequired,
  //   title: PropTypes.string,
  //   cancelTitle: PropTypes.string,
  //   actionTitle: PropTypes.string,
  //   isOpen: PropTypes.bool,
  // }

  render() {

    const { title, message, cancelTitle, actionTitle } = this.props
    return(
    <Modal
    // portalClassName="react-modal-portal"
    className="react-modal-content"
    closeTimeoutMS={300}
    isOpen={this.props.isOpen}
    onRequestClose={() => this.props.onClose()}
    shouldCloseOnEsc={!this.props.actionLoading}
    shouldCloseOnOverlayClick={false}
    style={{
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(100,100,100,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      content: {
        border: '1px solid #375430',
        backgroundColor: 'white',
        borderRadius: '0px',
        outline: 'none',
        padding: '20px',
        elevation: 8,
        boxShadow: '6px 6px rgba(0,0,0,0.5)',
        }
    }}
    >
    <div style={{
      height: 180,
      width: 200,
      userSelect: 'none',
    }}>
      <div style={{
        fontSize: '16pt',
        fontWeight: 'bold',
        // marginBottom: '16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Question style={{color: 'red', fontSize: '20pt', marginRight: '8px'}} />{title}</div>
      <div style={{textAlign: 'center', marginTop: 12, userSelect: 'none'}}>
        {stringFromStringWithLineBreaks(message)}
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '16px',
        left: 16,
        right: 16,
      }}>
      <Button
        variant="outlined"
        size="medium"
        className="confirm-button"
        style={{
          width: 80,
          height: 40,
          fontSize: '10pt',
          backgroundColor: '#CCC',
          color: '#333',
          borderColor: '#666',
          borderRadius: '6px',
          // boxShadow: '2px 2px rgba(0,0,0,0.25)',

        }}
        disabled={this.props.actionLoading || this.props.cancelDisabled}


        onClick={() => this.props.onCancel()}
        >
        {cancelTitle}
      </Button>
      <Button
        variant="contained"
        disableElevation
        size="large"
        className="confirm-button"
        style={{
          width: 80,
          marginLeft: 16,
          height: 40,
          borderRadius: '6px',          
          fontSize: '10pt',
          backgroundColor: '#bd0404', color: 'white',
          boxShadow: '2px 2px rgba(0,0,0,0.25)',
          // display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'
        }}
        disabled={this.props.actionLoading || this.props.actionDisabled}
        onClick={() => {
          this.props.onAction()

        //   this.setState({loadingConfirm: true})
        //   doFetch({
        //     action: 'del-occur',
        //     data: this.state.delId,
        //   }).then((res) => 
        //   {
        //     let occurs = this.state.occurs.filter((o) => o.id !== this.state.delId)
        //     this.setState({modal: 'none', snackBarOpen: true, snackbarText: 'Ocorrência excluída.', occurs})
        //     // this.fetchData()
        //   })

        }}
        >
        {this.props.actionLoading === false ? actionTitle : 
          <Loader color="#FFF" type="TailSpin" width={22} height={22} />
        }
      </Button>
      </div>
    </div>
    </Modal>
    )

  }

}